import { EventBus } from '@/plugins/event-bus'

const moduleState = {
  bulkChangeOrders: [],
  bulkChangeOrder: {
    BulkChangeOrderId: '',
    BrandCode: '',
    DealerId: '',
    OriginalExcelRows: [],
    ChangeOrders: null,
  },
}

const getters = {
  allBulkChangeOrders: (state) => state.bulkChangeOrders,
  getBulkChangeOrder: (state) => state.bulkChangeOrder,
}

const mutations = {
  setBulkChangeOrder: (state, payload) => {
    state.bulkChangeOrder = payload
  },
  setBulkChangeOrders: (state, payload) => {
    state.bulkChangeOrders = payload
    EventBus.$emit('bulkChangeOrder/allBulkChangeOrders')
  },
}

const actions = {
  setBulkChangeOrder: ({ commit }, payload) => {
    commit('setBulkChangeOrder', payload)
  },
  setBulkChangeOrders: ({ commit, state }, payload) => {
    commit('setBulkChangeOrders', payload)
  },
  resetBulkChangeOrders: ({ commit }) => {
    commit('setBulkChangeOrders', [])
  },
}
export default {
  state: moduleState,
  getters,
  mutations,
  actions,
  namespaced: true,
}
